import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatoMil'
})
export class FormatoMilPipe implements PipeTransform {

  public transform(value: any): any {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

}
